module.exports = __webpack_public_path__ + "img/empilhadeiras_pag6.f4621309.jpg";